import React, { useState } from 'react';
import './TestimonialsManagement.css';

/**
 * 🎯 TESTIMONIALS MANAGEMENT COMPONENT 2025
 * 
 * Toggle-Sektion für Simplistic Testimonial nach Design-Guide:
 * - 1:1 Text-Edit-Design
 * - Dynamische Testimonials kompakt zusammengefasst
 * - Image-Upload für jedes Testimonial
 * - Add/Remove-Funktionalität
 * - Spezifische Klassennamen
 */
function TestimonialsManagement({
    testimonials,
    addTestimonial,
    removeTestimonial,
    updateTestimonial,
    handleTestimonialImageUpload,
    uploadingStates,
    editData
}) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="testimonials-management">
            {/* Toggle Header */}
            <div 
                className={`testimonials-header ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
            >
                <div className="testimonials-header-content">
                    <div className="testimonials-header-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 1L10 5H14L11 8L12 12L8 10L4 12L5 8L2 5H6L8 1Z" stroke="currentColor" strokeWidth="1.2"/>
                            <path d="M8 6V10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <h3 className="testimonials-header-title">Testimonials</h3>
                    <div className="testimonials-counter">
                        {testimonials?.length || 0}
                    </div>
                </div>
                <div className={`testimonials-toggle-arrow ${isExpanded ? 'expanded' : ''}`}>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path 
                            d="M4 6L8 10L12 6" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>

            {/* Expanded Content */}
            {isExpanded && (
                <div className="testimonials-content">
                    {/* Add Button */}
                    <div className="add-testimonial-section">
                        <button
                            onClick={addTestimonial}
                            className="add-testimonial-btn"
                        >
                            <div className="btn-icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M7 3V11M3 7H11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                            </div>
                            <span>Add New Testimonial</span>
                        </button>
                        <div className="add-testimonial-hint">
                            Create compelling testimonials to build trust and credibility
                        </div>
                    </div>

                    {/* Testimonials Grid */}
                    {testimonials && testimonials.length > 0 && (
                        <div className="testimonials-grid">
                            {testimonials.map((testimonial, index) => (
                                <div key={testimonial.id || index} className="testimonial-edit-card">
                                    {/* Card Header */}
                                    <div className="testimonial-card-header">
                                        <div className="testimonial-card-title">
                                            <div className="testimonial-card-number">{index + 1}</div>
                                            <span>Testimonial</span>
                                        </div>
                                        <button
                                            onClick={() => removeTestimonial(index)}
                                            className="testimonial-remove-btn"
                                            title="Remove testimonial"
                                        >
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                            </svg>
                                        </button>
                                    </div>

                                    {/* Image Section */}
                                    <div className="testimonial-image-section">
                                        <div className="testimonial-image-preview-container">
                                            <div className="testimonial-image-preview">
                                                {testimonial.image ? (
                                                    <img
                                                        src={testimonial.image}
                                                        alt={`${testimonial.author || 'Testimonial'} Image`}
                                                        className="testimonial-image-img"
                                                    />
                                                ) : (
                                                    <div className="testimonial-image-placeholder">
                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                            <circle cx="10" cy="7" r="3" stroke="#dee2e6" strokeWidth="1.5"/>
                                                            <path d="M4 17v-1a4 4 0 014-4h4a4 4 0 014 4v1" stroke="#dee2e6" strokeWidth="1.5" strokeLinecap="round"/>
                                                        </svg>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Image Controls */}
                                        <div className="testimonial-image-controls">
                                            <label className="testimonial-image-control-btn upload" title="Upload image">
                                                {uploadingStates[index] ? (
                                                    <div className="testimonial-upload-spinner"></div>
                                                ) : (
                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M7 1V9M4 4L7 1L10 4M2 9V11C2 12.1 2.9 13 4 13H10C11.1 13 12 12.1 12 11V9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                )}
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) => {
                                                        if (e.target.files[0]) {
                                                            handleTestimonialImageUpload(index, e.target.files[0]);
                                                        }
                                                    }}
                                                    style={{ display: 'none' }}
                                                />
                                            </label>

                                            {testimonial.image && (
                                                <button
                                                    onClick={() => updateTestimonial(index, 'image', '')}
                                                    className="testimonial-image-control-btn clear"
                                                    title="Clear image"
                                                >
                                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                        <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                                                    </svg>
                                                </button>
                                            )}
                                        </div>
                                    </div>

                                    {/* Text Fields */}
                                    <div className="testimonial-content-section">
                                        <label className="testimonial-field-label">Testimonial Text</label>
                                        <textarea
                                            value={testimonial.text || ''}
                                            onChange={(e) => updateTestimonial(index, 'text', e.target.value)}
                                            placeholder="Enter testimonial text..."
                                            className="testimonial-textarea"
                                            rows={4}
                                        />
                                    </div>

                                    <div className="testimonial-content-section">
                                        <label className="testimonial-field-label">Author Name</label>
                                        <input
                                            type="text"
                                            value={testimonial.author || ''}
                                            onChange={(e) => updateTestimonial(index, 'author', e.target.value)}
                                            placeholder="Enter author name..."
                                            className="testimonial-input"
                                        />
                                    </div>

                                    <div className="testimonial-content-section">
                                        <label className="testimonial-field-label">Author Title</label>
                                        <input
                                            type="text"
                                            value={testimonial.title || ''}
                                            onChange={(e) => updateTestimonial(index, 'title', e.target.value)}
                                            placeholder="Enter author title..."
                                            className="testimonial-input"
                                        />
                                    </div>

                                    <div className="testimonial-content-section">
                                        <label className="testimonial-field-label">Website (Optional)</label>
                                        <input
                                            type="url"
                                            value={testimonial.website || ''}
                                            onChange={(e) => updateTestimonial(index, 'website', e.target.value)}
                                            placeholder="https://example.com"
                                            className="testimonial-input"
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Empty State */}
                    {(!testimonials || testimonials.length === 0) && (
                        <div className="testimonials-empty-state">
                            <div className="testimonials-empty-state-icon">
                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                                    <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3" opacity="0.3"/>
                                    <path d="M24 14L26 22H32L27 26L28 34L24 30L20 34L21 26L16 22H22L24 14Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
                                    <path d="M24 20V24" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
                                </svg>
                            </div>
                            <h4>No Testimonials Yet</h4>
                            <p>Click "Add New Testimonial" to create your first customer review</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default TestimonialsManagement;
